<template>
  <div class="scene-option">
    <div class="scene_title blue_header">
      <span>{{ $t('sceneTemplate.lightTripOption') }}</span>
    </div>
    <div class="scene_container">
      <div class="scene-option_item">
        <div class="scene-option_item_label">
          {{ $t('lastLight.brightness') }}:
        </div>
        <el-slider
          v-model="light"
          class="scene-option_slider"
          :min="0"
          :max="100"
        />
        <div class="scene-option_item_value">
          {{ light }} %
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // inject: ["handleSelectionChange", "doCallActionFun","deleteCardFun"],
  props: {
    option: {
      type: Object,
      default: () => ({
        light: 255
      })
    }
  },
  data() {
    return {
      light: 100
    }
  },

  computed: {
    showValue() {
        return this.value;
    }
  },

  watch: {
    option(value) {
      this.initLight(value);
    }
  },

  mounted() {
    this.initLight(this.option);
  },

  methods: {
    getValue() {
      return {
        light: Math.ceil(255 * (this.light / 100))
      }
    },

    initLight(value) {
      const light = (value || { light: 255}).light;
      this.light = Math.floor(light / 255 * 100)
    }
  },
};
</script>

<style lang="scss" scoped>
.scene-option {
  margin-bottom: 50px;

  &_item {
    display: flex;
    width: 400px;
    align-items: center;

    &_label {
      margin-right: 10px;
    }

    &_value {
      width: 40px;
      margin-left: 10px;
    }
  }

  &_slider {
    flex: 1;
  }
}
</style>